import { useToast } from 'vue-toastification';

const toast = useToast();

// initial state
const state = () => ({
    //
})

// getters
const getters = {
    //
}

// actions
const actions = {
    createSoundboard: async ({ commit }, payload) => {
        return axios.post('soundboard', payload).then(({ data }) => {
            return true;
        }).catch(({ response }) => {
            // console.log(response.data);
            // toast.error(response.data.message);
            throw response.data;
        });
    },

    deleteSoundboard: async ({ commit }, payload) => {
        return await axios.delete('soundboard/' + payload.id).then(() => {
            return true;
        }).catch(({ response }) => {
            // console.log(response.data);
            // toast.error(response.data.message);
            throw response.data;
        });
    },

    setActiveSoundboard: async ({ commit }, payload) => {
        let { data } = await axios.post('soundboard/' + payload + '/set-active');

        return data;
    },

    renameSoundboard: async ({ commit }, payload) => {
        let { data } = await axios.put('soundboard/' + payload.id, {
            name: payload.name
        });

        return data;
    }
}

// mutations
const mutations = {
    //
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
